import { getInstance as apiGetInstance } from "../api/ApiFactory";
import ServicoChamados from "./ServicoChamados";
import ServicoArvores from "./ServicoArvores";
import ServicoDatahub from "./ServicoDatahub";
import ServicoContexto from "./ServicoContexto";
import ServicoUsuarioInstitucional from "./ServicoUsuarioInstitucional";
import ServicoGuardiao from "./ServicoGuardiao";

var servicoChamadosInstance = null;
var servicoArvoresInstance = null;
var servicoDatahubInstance = null;
var servicoContexto = null;
var servicoUsuarioInstitucional = null;
var servicoGuardiao = null;

export function getServicoChamadosInstance() {
    if (!servicoChamadosInstance) {
        const api = apiGetInstance();
        servicoChamadosInstance = new ServicoChamados({ api });
    }
    return servicoChamadosInstance;
}

export function getServicoArvoresInstance() {
    if (!servicoArvoresInstance) {
        const api = apiGetInstance();
        servicoArvoresInstance = new ServicoArvores({ api });
    }
    return servicoArvoresInstance;
}

export function getServicoDatahubInstance() {
    if (!servicoDatahubInstance) {
        const api = apiGetInstance();
        servicoDatahubInstance = new ServicoDatahub({ api });
    }
    return servicoDatahubInstance;
}

export function getServicoContexto() {
    if (!servicoContexto) {
        const api = apiGetInstance();
        servicoContexto = new ServicoContexto({ api });
    }
    return servicoContexto;
}

export function getServicoUsuarioInstitucional() {
    if (!servicoUsuarioInstitucional) {
        const api = apiGetInstance();
        servicoUsuarioInstitucional = new ServicoUsuarioInstitucional({ api });
    }
    return servicoUsuarioInstitucional;
}

export function getServicoGuardiao() {
    if (!servicoGuardiao) {
        servicoGuardiao = new ServicoGuardiao();
    }
    return servicoGuardiao;
}
